module.exports = __webpack_public_path__ + "static/media/message-open.36d99891.svg";